<template>
  <base-content>
    <template v-slot:top>
      <hero-header :heading="edit ? 'Edit Support Article' : 'Create Support Article'">
        <base-button exact icon-left="arrow-left" :to="{ name: 'support-centre.admin' }">
          Support Centre
        </base-button>
      </hero-header>
    </template>

    <div class="my-4 py-4">
      <support-article-editor :edit="edit" @saved="saved" />
    </div>
  </base-content>
</template>

<script>
import HeroHeader from '@/components/HeroHeader.vue'
import SupportArticleEditor from '@/components/SupportArticleEditor.vue'

export default {
  async created () {
    const { id } = this.$route.params

    if (id) this.edit = id
  },

  data () {
    return {
      edit: null
    }
  },

  components: {
    HeroHeader,
    SupportArticleEditor
  },

  methods: {
    saved () {
      this.$router.push({ name: 'support-centre.admin' })
    }
  }
}
</script>
